module.exports = __webpack_public_path__ + "static/img/special_win_prize.0fcbb2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/special_win_prize.png
// module id = 478
// module chunks = 1